
import { useQuery } from '@tanstack/react-query';
import { fetchCategories } from "@/services/categories";

export const useCategoriesQuery = (config?: Parameters<typeof fetchCategories>[0]) => {
  return useQuery({
    queryKey: ['admin-categories'],
    queryFn: () => fetchCategories(config),
  });
};